export const TAB_CONTENT_PT_BR = {
	consolidated: "Competência",
	extract: "Extrato",
	revenueSettlement: "Apuração de Caixa",
	new: "NOVO",
	consolidatedTooltip:
		"Indica o período em que a venda ou operação foi realizada, independentemente da data de pagamento.",
	revenueSettlementTooltip:
		"Indica o período em que os valores foram efetivamente pagos ou recebidos.",
};

export type TabContentTranslations = typeof TAB_CONTENT_PT_BR;
